import React from 'react';
import Result from '../../Components/speech/Result';

const SpeechModule = () => {
  return (
    <Result />
  );
};

export default SpeechModule;
